import React from 'react'

const Service = () => {
  return (

    <div className="subpage policy">
      <h2 className="policy-title">
        서비스 이용약관
      </h2>

      <div className="policy-page">

        <div className="fulltext-item">
          <h2>
            [제1장 총칙]
          </h2>
          <p className="fulltext-title fulltext-title-bold">
            제1조(목적)
          </p>
          <p className="padding-bottom">
            이 약관은 주식회사 마인드아이티 (이하 '회사' 라고 합니다)가 제공하는 제반 서비스의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
          </p>
          <p>
            이용자는 본 이용약관을 자세히 읽은 후 이용약관에 동의하지 않을 경우, 본 이용약관에 동의하거나, 서비스에 등록 또는 액세스하거나 이를 이용(이하 “이용”)하지 말아야 합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제2조(정의)
          </p>
          <p className="padding-bottom">
            이 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.
          </p>
          <div className="padding-left">
            <p className="padding-bottom">
              1. '서비스'라 함은 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 '이용자'가 이용할 수 있는 회사가 제공하는 제반 서비스를 의미합니다.
            </p>
            <p className="padding-bottom">
              2. '이용자'란 이 약관에 따라 회사가 제공하는 서비스를 받는 '개인회원', '상담사회원' 및 '비회원'을 말합니다.
            </p>
            <p className="padding-bottom">
              3. '개인회원'은 회사에 개인정보를 제공하여 회원등록을 한 사람으로, 회사로부터 지속적으로 정보를 제공받고 '회사'가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
            </p>
            <p className="padding-bottom">
              4. '상담사회원'은 회사에 개인정보 및 이력을 제공하여 회원등록을 한 사람으로, 회사로부터 지속적으로 정보를 제공받고 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
            </p>
            <p className="padding-bottom">
              5. '비회원'은 회원가입 없이 회사가 제공하는 서비스를 이용하는 자를 말합니다.
            </p>
            <p className="padding-bottom">
              6. '아이디(ID)'라 함은 회원의 식별과 서비스이용을 위하여 회원이 정하고 회사가 승인하는 문자 또는 문자와 숫자의 조합을 의미합니다.
            </p>
            <p className="padding-bottom">
              7. '비밀번호'라 함은 회원이 부여받은 아이디와 일치되는 회원임을 확인하고 비밀의 보호를 위해 회원 자신이 정한 문자(특수문자 포함)와 숫자의 조합을 의미합니다.
            </p>
            <p className="padding-bottom">
              8. '유료서비스'라 함은 회사가 유료로 제공하는 제반 서비스를 의미합니다.
            </p>
            <p className="padding-bottom">
              9. '결제'란 회사가 제공하는 유료서비스를 이용하기 위하여 회원이 지불수단을 선택하고, 금융정보를 입력하는 행위를 말합니다.
            </p>
            <p className="padding-bottom">
              10. 마인드인사이트 : 마인드아이티에서 자체개발한 심리검사 서비스인 동시에 모든 상품을 포괄하는 종합정신건강솔루션 서비스
            </p>
            <p className="padding-bottom">
              11. 마인드리포트: 심리 검사 결과를 실물책으로 발송하는 서비스
            </p>
            <p className="padding-bottom">
              12. 마인드임팩트: 마인드아이티에서 운영하고 있는 상담코칭센터
            </p>
            <p className="padding-bottom">
              13. 마인드테라피: 온/오프라인에서 진행되는 테라피 프로그램
            </p>
            <p className="padding-bottom">
              14. 사피엔자 아카데미아: 마인드아이티에서 운영하고 있는 평생교육원
            </p>
            <p className="padding-bottom">
              15. 심리상담 서비스감정분석 및 심리검사 등의 심리분석/관리 솔루션 서비스
            </p>
            <p className="padding-bottom">
              16. 정신건강을 위한 테라피 판매 서비스
            </p>
            <p className="padding-bottom">
              17. 기타 회사가 추가 개발하거나 다른 회사 혹은 개인과 제휴 및 계약 등을 통해 제공하는 서비스
            </p>
          </div>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제3조(약관 외 준칙)
          </p>
          <p>
            이 약관에서 정하지 아니한 사항에 대해서는 법령 또는 회사가 정한 서비스의 개별약관, 운영정책 및 규칙 등(이하 세부지침)의 규정에 따릅니다. 또한 본 약관과 세부지침이 충돌할 경우에는 세부지침에 따릅니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제4조(약관의 효력과 변경)
          </p>
          <p className="padding-bottom">
            1. 이 약관은 주식회사 마인드아이티(이)가 제공하는 모든 인터넷서비스에 게시하여 공시합니다. '회사'는 ‘전자상거래 등에서의 소비자보호에 관한 법률(이하 '전자상거래법'이라 함)', '약관의 규제에 관한 법률(이하 '약관규제법'이라 함)', '전자문서 및 전자거래 기본법(이하 '전자문서법'이라 함)', ‘전자금융거래법 ‘, '정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법'이라 함)', '소비자기본법' 등 관계 법령(이하 '관계법령' 이라 함)에 위배되지 않는 범위 내에서 이 약관을 변경할 수 있으며, 회사는 약관이 변경되는 경우에 변경된 약관의 내용과 시행일을 정하여, 그 시행일로부터 최소 7일 (이용자에게 불리하거나 중대한 사항의 변경은 30일) 이전부터 시행일 후 상당한 기간 동안 공지하고, 기존 이용자에게는 변경된 약관, 적용일자 및 변경사유(변경될 내용 중 중요사항에 대한 설명을 포함)를 별도의 전자적 수단(전자우편, 문자메시지, 서비스 내 전자쪽지발송, 알림 메시지를 띄우는 등의 방법)으로 개별 통지합니다. 변경된 약관은 공지하거나 통지한 시행일로부터 효력이 발생합니다.
          </p>
          <p className="padding-bottom">
            2. 회사가 제1항에 따라 개정약관을 공지 또는 통지하는 경우 '변경에 동의하지 아니한 경우 공지일 또는 통지를 받은 날로부터 7일(이용자에게 불리하거나 중대한 사항의 변경인 경우에는 30일) 내에 계약을 해지할 수 있으며, 계약해지의 의사표시를 하지 아니한 경우에는 변경에 동의한 것으로 본다.' 라는 취지의 내용을 함께 통지합니다.
          </p>
          <p className="padding-bottom">
            3. 이용자가 제2항의 공지일 또는 통지를 받은 날로부터 7일(또는 이용자에게 불리하거나 중대한 사항의 변경인 경우에는 30일)내에 변경된 약관에 대해 거절의 의사를 표시하지 않았을 때에는 본 약관의 변경에 동의한 것으로 간주합니다.
          </p>
          <p>
            4. 본 약관에 밝히지 않은 사항은 전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계 법령 및 회사가 정한 서비스의 세부이용지침 등의 규정을 따른다.회사는 필요하면 서비스에 적용될 사항 및 세부 이용지침(이하 “개별약관”)을 정하여 이를 제3조 제2항의 방법에 따라 공지할 수 있다.본 약관과 관련하여 회사의 정책 변경, 법령의 제·개정 또는 공공기관의 고시나 지침 등에 따라 회사가 홈페이지의 공지사항 게시판 등을 통해 공지하는 내용도 이용계약의 일부를 구성한다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제5조(이용자에 대한 통지)
          </p>
          <p className="padding-bottom">
            1. 회사는 이 약관에 별도 규정이 없는 한 이용자에게 전자우편, 문자메시지(SMS), 전자쪽지, 푸쉬(Push)알림 등의 전자적 수단을 이용하여 통지할 수 있습니다.
          </p>
          <p className="padding-bottom">
            2. 회사는 이용자 전체에 대한 통지의 경우 7일 이상 회사가 운영하는 웹사이트 내의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다. 다만, 이용자 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 제1항의 개별 통지를 합니다.
          </p>
          <p>
            3. 회사는 이용자의 연락처 미기재, 변경 후 미수정, 오기재 등으로 인하여 개별 통지가 어려운 경우에 한하여 전항의 공지를 함으로써 개별 통지를 한 것으로 간주합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <h2>
            [제2장 서비스 이용계약]
          </h2>
          <p className="fulltext-title fulltext-title-bold">
            제6조(이용계약의 체결)
          </p>
          <p className="padding-bottom">
            이용계약은 다음의 경우에 체결됩니다.
          </p>
          <div className="padding-left">
            <p className="padding-bottom">
              1. 이용자가 회원으로 가입하고자 하는 경우 이용자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 회사가 이러한 신청에 대하여 승낙한 때
            </p>
            <p className="padding-bottom">
              2. 이용자가 회원 가입 없이 이용할 수 있는 서비스에 대하여 회원 가입의 신청없이 서비스를 이용하고자 하는 경우에는 회사 서비스 이용을 위해 결제하는 때
            </p>
            <p>
              3. 이용자가 회원가입 없이 이용할 수 있는 서비스에 대하여 회원가입의 신청없이 무료 서비스를 이용하고자 하는 경우에는 그 무료 서비스와 관련된 사항의 저장 등 부가서비스를 이용하면서 위 1호 및 2호의 절차를 진행한 때
            </p>
          </div>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제7조(회원가입에 대한 승낙)
          </p>
          <p className="padding-bottom">
            1. 회사는 이용계약에 대한 요청이 있을 때 서비스 이용을 승낙함을 원칙으로 합니다.
          </p>
          <p className="padding-bottom">
            2. 전항에도 불구하고, 다음 각호의 사유에 해당하는 경우 회사는 회원가입을 보류하거나 거절하는 등 제한할 수 있습니다.
          </p>
          <div className="padding-left padding-bottom">
            <div className="padding-bottom">
              가. 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우(단, 회사의 재가입 승낙을 얻은 경우에는 예외로 함)
            </div>
            <div className="padding-bottom">
              나. 실명이 아니거나 타인의 명의를 도용한 경우
            </div>
            <div className="padding-bottom">
              다. 회사가 정하는 필수정보를 누락하거나 허위로 기재한 경우
            </div>
            <div className="padding-bottom">
              라. 만 14세 미만의 아동, 만 19세 미만의 미성년자, 피한정후견인, 피성년후견인이 법정대리인의 동의를 얻지 않은 경우
            </div>
            <div className="padding-bottom">
              마. 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 이 약관 등 회사가 규정한 운영원칙을 위반한 경우
            </div>
            <div className="padding-bottom">
              바. 신용정보의 이용과 보호에 관한 법률에 따라 PC통신, 인터넷서비스의 신용불량자로 등록되어 있는 경우
            </div>
            <div className="padding-bottom">
              사. 정보통신윤리위원회에 PC통신, 인터넷서비스의 불량이용자로 등록되어 있는 경우
            </div>
            <div className="padding-bottom">
              아. 이미 사용 중인 회원정보 또는 공서양속을 저해하는 아이디를 사용하고자 하는 경우
            </div>
          </div>
          <p className="padding-bottom">
            3. 제1항에 따른 신청에 있어 회사는 서비스 제공에 필요한 경우 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
          </p>
          <p className="padding-bottom">
            4. 회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
          </p>
          <p className="padding-bottom">
            5. 제2항과 제4항에 따라 서비스 이용을 승낙하지 아니하거나 유보한 경우, 회사는 원칙적으로 이를 서비스 이용 신청자에게 알리도록 합니다. 단, 회사의 귀책사유 없이 이용자에게 알릴 수 없는 경우에는 예외로 합니다.
          </p>
          <p className="padding-bottom">
            6. 이용계약의 성립 시기는 제6조 제1호의 경우에는 회사가 가입완료를 신청절차 상에서 표시한 시점, 제6조 제2호의 경우에는 결제가 완료되었다는 표시가 된 시점으로 합니다.
          </p>
          <p className="padding-bottom">
            7. 회사는 회원에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.
          </p>
          <p className="padding-bottom">
            8. 회사는 회원에 대하여 '영화및비디오물의진흥에관한법률' 및 '청소년보호법' 등에 따른 등급 및 연령 준수를 위하여 이용제한이나 등급별 제한을 둘 수 있습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제8조(회원정보의 변경)
          </p>
          <p className="padding-bottom">
            1. 회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.
          </p>
          <p className="padding-bottom">
            2. 회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 회사에 대하여 그 변경사항을 알려야 합니다.
          </p>
          <p className="padding-bottom">
            3. 제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여는 회원에게 책임이 있습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제8조(회원정보의 변경)
          </p>
          <p className="padding-bottom">
            1. 회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.
          </p>
          <p className="padding-bottom">
            2. 회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 회사에 대하여 그 변경사항을 알려야 합니다.
          </p>
          <p className="padding-bottom">
            3. 제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여는 회원에게 책임이 있습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제9조(회원정보와 상담정보)
          </p>
          <p className="padding-bottom">
            1. 회원의 아이디(ID)와 비밀번호에 관한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.
          </p>
          <p className="padding-bottom">
            2. 회사는 회원의 아이디(ID)가 개인정보 유출 우려가 있거나, 반사회적 또는 공서양속에 어긋나거나, 회사 또는 서비스의 운영자로 오인할 우려가 있는 경우, 해당 아이디(ID)의 이용을 제한할 수 있습니다.
          </p>
          <p className="padding-bottom">
            3. 회원은 아이디(ID) 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 안내에 따라야 합니다.
          </p>
          <p className="padding-bottom">
            4. 제3항의 경우 해당 회원이 회사에 그 사실을 통지하지 않거나, 통지하였으나 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.
          </p>
          <p className="padding-bottom">
            5. 회원이 전항의 변경사항을 수정하지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.
          </p>
          <p className="padding-bottom">
            6. 서비스의 제공 및 이용을 위하여 일반 회원의 개인정보와 상담 내용 등은 회사와 상담사 회원이 공유하며, 개인정보의 수집과 공유항목 등 세부적인 사항은 개인정보 처리방침을 확합니다.
          </p>
          <p className="padding-bottom">
            7. 효율적인 상담을 위하여 일반 회원은 상담 전 상담 접수지를 작성 제출하며, 상담 접수 시 수집되는 일반 회원의 정보에는 서비스의 특성상 민감정보가 포함될 수 있다는 사실을 인정합니다.
          </p>
          <p className="padding-bottom">
            8. 효율적이고도 지속적인 상담을 위하여 일반 회원 개인정보, 접수 정보 그리고 회사가 운영하는 앱이나 인터넷 사이트 등 플랫폼 상의 상담 내용, 일반 회원이 게시한 글이나 사진 등 저작물 등 상담 서비스 관련 모든 정보와 자료는 회사가 보관하면서, 상담사 회원과 공유할 수 있습니다.
          </p>
          <p className="padding-bottom">
            9. 더 나아가 상기 상담 서비스 관련 모든 정보와 자료는 서비스의 제공, 더 나은 서비스의 개발과 상담연구, 통계, 홍보, 빅데이터 활용 내지 연구를 위한 제3자에 대한 양도 등을 위하여 활용될 수 있다는 사실을 인정하고 동의합니다.
          </p>
          <p className="padding-bottom">
            10. 상담사 회원은 개인정보 중 프로필 사진, 학력 정보, 자격 정보, 경력 정보 등 서비스 운영을 위해 확인이 필요한 정보를 변경한 경우, 해당 정보를 입증할 수 있는 자료를 제출해야 합니다. 내부 규정에 적합하지 않은 정보 또는 입증이 불가능한 정보인 경우, 상담사 회원의 활동을 중단할 수 있습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제10조(회사의 의무)
          </p>
          <p className="padding-bottom">
            1. 회사는 계속적이고 안정적인 서비스의 제공을 위하여 설비에 장애가 생기거나 멸실된 때에는 이를 지체 없이 수리 또는 복구하며, 다음 각 호의 사유 발생 시 부득이한 경우 예고 없이 서비스의 전부 또는 일부의 제공을 일시 중지할 수 있습니다. 이 경우 그 사유 및 중지 기간 등을 이용자에게 지체 없이 사후 공지합니다.
          </p>
          <div className="padding-left padding-bottom">
            <div className="padding-bottom">
              가. 시스템의 긴급점검, 증설, 교체, 시설의 보수 또는 공사를 하기 위하여 필요한 경우
            </div>
            <div className="padding-bottom">
              나. 새로운 서비스를 제공하기 위하여 시스템교체가 필요하다고 판단되는 경우
            </div>
            <div className="padding-bottom">
              다. 시스템 또는 기타 서비스 설비의 장애, 유무선 Network 장애 등으로 정상적인 서비스 제공이 불가능할 경우
            </div>
            <div className="padding-bottom">
              라. 국가비상사태, 정전, 불가항력적 사유로 인한 경우
            </div>
          </div>
          <p className="padding-bottom">
            2. 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 이용자와의 계약관련 절차 및 내용 등에 있어 이용자에게 편의를 제공하도록 노력합니다.
          </p>
          <p className="padding-bottom">
            3. 회사는 대표자의 성명, 상호, 주소, 전화번호, 모사전송번호(FAX), 통신판매업 신고번호, 이용약관, 개인정보취급방침 등을 이용자가 쉽게 알 수 있도록 온라인 서비스 초기화면에 게시합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제11조(개인정보보호)
          </p>
          <p className="padding-bottom">
            1. 회사는 이용자들의 개인정보를 중요시하며, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 관련 법규를 준수하기 위해 노력합니다. 회사는 개인정보보호정책을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
          </p>
          <p className="padding-bottom">
            2. 회사가 이용자의 개인정보의 보호 및 사용에 대해서 관련 법규 및 회사의 개인정보처리방침을 적용합니다. 다만, 회사에서 운영하는 웹 사이트 등에서 링크된 외부 웹페이지에서는 회사의 개인정보처리방침이 적용되지 않습니다.
          </p>
          <p className="padding-bottom">
            3. 회사는 회원의 개인정보에 대하여 철저한 보안을 유지하여야 하며 서비스 운영 및 개선에만 사용하여야 하고, 이외의 목적으로 타 기관 및 개인에게 제공하지 않습니다. 다만 다음 각 호에 해당하는 경우에는 그렇지 않습니다.
          </p>
          <div className="padding-left padding-bottom">
            <div className="padding-bottom">
              a&#41; 관계법령에 의해 수사상의 목적으로 관계기관으로부터 요청이 있는 경우
            </div>
            <div className="padding-bottom">
              b&#41; 정보통신윤리위원회의 요청이 있는 경우
            </div>
            <div className="padding-bottom">
              c&#41; 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우회사는 회원의 개인정보 관리를 위하여 회원의 개인정보를 제3자에게 위탁할 수 있습니다.
            </div>
          </div>
          <p className="padding-bottom">
            4. 회사는 회원의 귀책사유로 인하여 노출된 개인정보에 대하여서는 일체의 책임을 지지 않습니다.
          </p>
          <p className="padding-bottom">
            5. 회사는 상담사 회원에게 제공 공유된 일반 회원 정보에 관하여 계약 해지 또는 회원자격 박탈 시점에 따라 일반 회원의 모든 개인정보와 상담내용 등 자료를 제출 받거나 폐지하도록 요구합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제12조(이용자의 의무)
          </p>
          <p className="padding-bottom">
            1. 이용자는 이용자가입을 통해 이용신청을 하는 경우 사실에 근거하여 신청서를 작성해야 합니다. 이용자가 허위, 또는 타인의 정보를 등록한 경우 회사에 대하여 일체의 권리를 주장할 수 없으며, 회사는 이로 인하여 발생한 손해에 대하여 책임을 부담하지 않습니다.
          </p>
          <p className="padding-bottom">
            2. 이용자는 본 약관에서 규정하는 사항과 기타 회사가 정한 제반 규정, 회사가 공지하는 사항을 준수하여야 합니다.  또한 이용자는 회사의 업무를 방해하는 행위 및 회사의 명예를 훼손하는 행위를 하여서는 안 됩니다.
          </p>
          <p className="padding-bottom">
            3. 이용자는 주소, 연락처, 전자우편 주소 등 회원정보가 변경된 경우 즉시 온라인을 통해 이를 수정해야 합니다. 이 때 변경된 정보를 수정하지 않거나 수정이 지연되어 발생하는 책임은 이용자가 지게 됩니다.
          </p>
          <p className="padding-bottom">
            4. 이용자는 이용자에게 부여된 아이디와 비밀번호를 직접 관리해야 합니다. 이용자의 관리 소홀로 발생한 문제는 회사가 책임을 부담하지 않습니다.
          </p>
          <p className="padding-bottom">
            5. 이용자가 아이디, 닉네임, 기타 서비스 내에서 사용되는 명칭 등을 선정할 때에는 다음 각 호에 해당하는 행위를 해서는 안 됩니다.
          </p>
          <p className="padding-bottom">
            6. 회사가 제공하는 서비스의 공식 운영자를 사칭하거나 이와 유사한 명칭을 사용하여 다른 이용자에게 혼란을 주는 행위
          </p>
          <p className="padding-bottom">
            7. 선정적이고 음란한 내용이 포함된 명칭을 사용하는 행위
          </p>
          <p className="padding-bottom">
            8. 제3자의 상표권, 저작권 등 권리를 침해할 가능성이 있는 명칭을 사용하는 행위
          </p>
          <p className="padding-bottom">
            9. 제3자의 명예를 훼손하거나, 그 업무를 방해할 가능성이 있는 명칭을 사용하는 행위
          </p>
          <p className="padding-bottom">
            10. 기타 반사회적이고 관계법령에 저촉되는 내용이 포함된 명칭을 사용하는 행위
          </p>
          <p className="padding-bottom">
            11. 이용자는 회사의 명시적 동의가 없는 한 서비스 이용 권한, 기타 이용 계약상의 지위에 대하여 매도, 증여, 담보제공 등 처분행위를 할 수 없습니다.
          </p>
          <p className="padding-bottom">
            12. 회원은 아이디와 비밀번호에 대한 모든 관리책임이 있으며, 이를 제3자에게 제공 또는 공유, 공개하여 제3자가 이용하도록 할 수 없습니다.
          </p>
          <p className="padding-bottom">
            13. 회사는 전항의 경우 회원의 자격을 박탈할 수 있습니다.
          </p>
          <p className="padding-bottom">
            14. 회원은 자신의 아이디 및 비밀번호가 유출되어 제3자에 의해 사용되고 있음을 인지한 경우, 즉시 회사에 알려야 합니다.
          </p>
          <p className="padding-bottom">
            15. 회사는 전항의 경우 회원의 개인정보보호 및 기타 서비스 부정이용행위 방지 등을 위하여 회원에게 비밀번호의 변경 등 필요한 조치를 요구할 수 있으며, 회원은 회사의 요구가 있는 즉시 회사의 요청에 성실히 응해야 합니다.
          </p>
          <p className="padding-bottom">
            16. 회사는 회원이 본조 제1항 및 제3항에 따른 의무를 성실히 이행하지 않아 발생한 불이익에 대하여 책임지지 않습니다.
          </p>
          <p className="padding-bottom">
            17. 본 조와 관련하여 서비스 이용에 있어 주의사항 등 그 밖의 자세한 내용은 운영정책으로 정하며, 이용자가 서비스 이용약관 및 운영정책을 위반하는 경우 서비스 이용제한, 민형사상의 책임 등 불이익이 발생할 수 있습니다.
          </p>
          <p className="padding-bottom">
            18. 일반 회원이 회사가 제공하는 상담 서비스를 이용함에 있어서 상담사 회원으로부터 상담을 받기 위하여는 상품을 구매하여야 하며, 상품의 환불에 대하여는 회사가 별도로 공지하는 환불규정을 따르기로 합니다.
          </p>
          <p className="padding-bottom">
            19. 일반 회원은 관계법령, 본 약관의 규정, 이용안내 및 서비스 상에 공지한 주의사항, 회사가 통지한 사항을 준수해야 하며, 기타 회사의 업무를 방해하는 행위를 할 수 없습니다.
          </p>
          <p className="padding-bottom">
            20. 일반 회원은 심리상담을 받기 위한 목적으로만 서비스를 이용하여야 하며, 학술적 의문의 해소, 광고, 스토킹, 장난 등의 목적으로 서비스를 이용할 수 없습니다.
          </p>
          <p className="padding-bottom">
            21. 일반 회원은 서비스 이용에 필요한 최소한의 구체적이고도 진실한 정보를 제공하여야 하며, 정보부족 시 서비스의 이용에 제한을 받을 수 있습니다. 단, 일반 회원 자신과 타인의 개인정보 등을 작성하는 방법 등으로 타인의 명예를 훼손하거나 기타 권리를 침해할 수 없습니다.
          </p>
          <p className="padding-bottom">
            22. 일반 회원은 상담사 회원으로부터 받은 상담의 내용을 회사의 사전 서면 승낙 없이 제3자에게 공개하거나 복제ㆍ편집ㆍ전시ㆍ전송ㆍ배포ㆍ판매ㆍ방송ㆍ공연하는 등의 행위를 할 수 없습니다.
          </p>
          <p className="padding-bottom">
            23. 일반 회원은 서비스에 등록된 상담사 회원의 귀책사유 있는 불법 내지 위법행위를 알게 된 경우, 회사에게 해당 사실을 통지하여야 합니다.
          </p>
          <p className="padding-bottom">
            24. 이 경우 회사는 관련 사실관계를 확인하고, 상담사 회원의 회원 자격박탈 등의 필요한 조치를 취합니다.
          </p>
          <p className="padding-bottom">
            25. 일반 회원은 상담사 회원에 대한 책임 청구 이외에 회사에 대하여는 상담사 회원의 귀책사유 있는 불법 내지 위법행위에 대한 책임을 물을 수 없습니다.
          </p>
          <p className="padding-bottom">
            26. 의도적으로 상담과 무관한 내용으로 상담을 방해하거나 기타 행위로 상담사에게 불쾌감을 유발할 경우 상담사 회원은 '본 행위가 반복될 경우에 상담을 강제종료할 수 있음'을 알릴 수 있으며, 알림 후 동일한 행위가 재반복되면 상담을 강제 종료할 수 있습니다. 이 경우 상품은 환불되지 않습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제13조(상담사 회원의 권리와 의무)
          </p>
          <p className="padding-bottom">
            1. 상담사 회원은 일반 회원에게 상담 서비스를 제공할 수 있습니다.
          </p>
          <p className="padding-bottom">
            2. 상담사 회원은 광고, 브로커제안, 스토킹, 장난 등 마인드아이티 서비스의 취지에 부합하지 않는 목적으로 상담을 요청하는 일반 회원에 대하여 회사 또는 경찰 등 유관기관에 신고할 수 있습니다.
          </p>
          <p className="padding-bottom">
            3. 상담사 회원은 회사의 요청이 있는 경우, 학력 및 심리 상담 관련 자격증 정보 등의 최소한의 정보를 공개해야 합니다.
          </p>
          <p className="padding-bottom">
            4. 상담사 회원은 회사에게 전항의 정보를 전달함에 있어 진실에 부합하게 하여야 하고, 회사가 관련 증명서류를 요청할 경우 이에 응하여야 합니다.
          </p>
          <p className="padding-bottom">
            5. 상담사 회원은 상담 업무 제공과 서비스 플랫폼 운영을 위하여 이름, 사진 등 개인정보가 회사의 앱이나 인터넷 사이트 등 플랫폼 상에서 공개될 수 있고, 더 나아가 회사의 홍보를 위하여 상담사 회원이 동의한 개인정보 항목에 대해 매체 혹은 외부에 소개될 수 있습니다.
          </p>
          <p className="padding-bottom">
            6. 상담사 회원은 회사가 제공하는 서비스의 지적재산권을 침해하는 행위를 할 수 없습니다.
          </p>
          <p className="padding-bottom">
            7. 상담사 회원은 회원과의 상담 내용에 대하여 비밀준수의무를 지며, 본 항의 의무는 이용계약 해지 이후에도 유지됩니다.
          </p>
          <p className="padding-bottom">
            8. 상담사 회원은 상담 활동을 진행할 때 상담사의 윤리강령을 준수해야만 하며, 윤리강령은 사단법인 한국상담심리학회 윤리강령을 준용합니다.
          </p>
          <p className="padding-bottom">
            9. 상담사 회원은 상담 업무 이행 과정에서 회사의 앱이나 인터넷 사이트 등 플랫폼 상에서 제공 받는 등 공유하거나 취득하게 된 회사 내지 일반 회원의 모든 정보를 상담 업무 이행을 위해서만 활용하고, 다른 목적으로 사용하지 않습니다.
          </p>
          <p className="padding-bottom">
            10. 상담사 회원은 서비스 내에서 활동함에 취득한 정보에 대해서는 회사의 서면 동의 없이 제3자에게 누설하거나 타목적에 이용해서는 아니되며, 본 항의 의무는 이용계약 해지 이후에도 유지됩니다.
          </p>
          <p className="padding-bottom">
            11. 상담사 회원은 상담 진행 시 일반 회원과 미리 정한 예약 시간을 준수하여 약속한 횟수와 시간에 따라 상담을 진행하여야 합니다.
          </p>
          <p className="padding-bottom">
            12. 상담사 회원은 일반 회원의 개인정보 내지 상담 정보를 무단으로 수집•저장•공개하는 행위, 일반 회원의 명예를 손상하거나 불이익을 주는 행위를 할 수 없습니다.
          </p>
          <p className="padding-bottom">
            13. 상담사 회원은 일반 회원의 요청이 있을 때 회사의 사전 동의를 얻은 후 오프라인 상담이나 기타 기관을 추천해줄 수 있습니다.
          </p>
          <p className="padding-bottom">
            14. 상담사 회원은 이 약관과 회사가 서비스 화면을 통하여 미리 공지하는 약관 등이 정하는 절차에 따라 신원정보의 제공, 개인 프로필 정보의 등록, 판매서비스권 등록, 거래진행과정의 관리, 회원에 대한 상담 이행, CS 등의 사후처리를 수행해야 합니다.
          </p>
          <p className="padding-bottom">
            15. 회사는 상담사 회원이 등록한 프로필의 판매 촉진 및 신뢰도 상승을 위해 서비스의 메인 이미지 또는 프로필 정보 등에 대한 등록 기준을 마련하여 상담사 회원에게 수정을 요청할 수 있으며, 상담사 회원은 이에 동의해야 합니다. 만일 이에 동의하지 않을 경우 회사는 상담사 회원의 서비스 활동을 제한할 수 있습니다.
          </p>
          <p className="padding-bottom">
            16. 상담사 회원은 상담권 판매로 발생한 수익금을 회사와 배분합니다. 수익 배분율은 내부 규정을 따르며, 상담사에 따라 개별계약이 있을 수 있습니다.
          </p>
          <p className="padding-bottom">
            17. 회사는 상담사 회원에게 수익금에 대한 정산자료를 제공하며, 정산내역에 대한 정정기간을 충분히 제공한다. 정산자료에 대한 이의제기, 정정 및 취소요청, 입금 계좌 변경 등은 정산자료 통보일에 안내된 수정 가능 기간에 한하여 가능하며, 회사의 과실로 인한 건이라도 해당 수정 가능 기간을 초과한 요청에 대해서는 정정이 불가하거나 다음 정산에 처리될 수 있습니다.
          </p>
          <p className="padding-bottom">
            18. 상담사 회원의 지급정보가 불충분하여 정산이 이뤄지지 않은 경우, 수입이 발생한 시점으로부터 3개월이 경과하면 해당 수입에 대한 회사의 지급의무가 소멸됩니다. 상담사 회원이 3개월 이내 지급정보를 입력하고 수입에 대한 정산을 청구할 수 있으며 이 경우 정산은 회사의 일정에 따라 지급됩니다.
          </p>
          <p>
            본 약관에 명시되지 않은 내용은 관련 법령 및 회사 내규를 따른다.
          </p>
        </div>
        <div className="fulltext-item">
          <h2>
            [제3장 서비스의 이용]
          </h2>
          <p className="fulltext-title fulltext-title-bold">
            제14조(서비스의 제공)
          </p>
          <p className="padding-bottom">
            1. 회사의 서비스는 연중무휴, 1일 24시간 제공을 원칙으로 합니다. 다만 회사 시스템의 유지 보수를 위한 점검, 통신장비의 교체 등 특별한 사유가 있는 경우 서비스의 전부 또는 일부에 대하여 일시적인 제공 중단이 발생할 수 있습니다.
          </p>
          <p className="padding-bottom">
            2. 회사가 제공하는 개별 서비스에 대한 구체적인 안내사항은 개별 서비스 화면에서 확인할 수 있습니다.
          </p>
          <p className="padding-bottom">
            3. 회사는 이용자에게 서비스에 대한 정보를 제공하며, 구매 계약을 체결할 수 있는 기능을 제공합다.다만, 유료 상담 서비스는 이용자가 검사코드를 구매하고 회원가입을 완료한 후에 실제 상담서비스를 제공받을 수 있습니다.
          </p>
          <p className="padding-bottom">
            4. 회사가 통제할 수 없는 사유로 인하여 서비스가 중단됨으로써 사전 공지가 불가능한 경우에는 사후 공지로 갈음합니다.
          </p>
          <p className="padding-bottom">
            5. 회사는 서비스가 변경되는 경우 변경되는 서비스 내용 및 제공일자를 사이트를 통하여 공지하거나 회원에게 통지합니다.
          </p>
          <p className="padding-bottom">
            6. 회사가 제공하는 서비스의 내용은 다음과 같습니다.
          </p>
          <div className="padding-left">
            <div className="padding-bottom">
              가. 마인드인사이트 : 마인드아이티에서 자체개발한 심리검사 서비스인 동시에 모든 상품을 포괄하는 종합정신건강솔루션 서비스
            </div>
            <div className="padding-bottom">
              나. 마인드리포트: 심리 검사 결과를 실물책으로 발송하는 서비스
            </div>
            <div className="padding-bottom">
              다. 마인드임팩트 : 마인드아이티에서 운영하고 있는 상담코칭센터
            </div>
            <div className="padding-bottom">
              라. 마인드테라피 : 온/오프라인에서 진행되는 테라피 프로그램
            </div>
            <div className="padding-bottom">
              마. 사피엔자 아카데미아 : 마인드아이티에서 운영하고 있는 평생교육원
            </div>
            <div className="padding-bottom">
              바. 심리상담 서비스감정분석 및 심리검사 등의 심리분석/관리 솔루션 서비스
            </div>
            <div className="padding-bottom">
              사. 정신건강을 위한 테라피 판매 서비스
            </div>
            <div className="padding-bottom">
              아. 기타 회사가 추가 개발하거나 다른 회사 혹은 개인과 제휴 및 계약 등을 통해 제공하는 서비스
            </div>
          </div>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제15조(서비스의 제한 등)
          </p>
          <p className="padding-bottom">
            1. 회사는 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우와 전기통신사업법에 의한 기간통신사업자가 전기통신서비스를 중지하는 등 부득이한 사유가 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
          </p>
          <p className="padding-bottom">
            2. 무료서비스는 전항의 규정에도 불구하고, 회사의 운영정책 등의 사유로 서비스의 전부 또는 일부가 제한되거나 중지될 수 있으며, 유료로 전환될 수 있습니다.
          </p>
          <p className="padding-bottom">
            3. 회사는 서비스의 이용을 제한하거나 정지하는 때에는 그 사유 및 제한기간, 예정 일시 등을 지체없이 이용자에게 알립니다.
          </p>
          <p className="padding-bottom">
            4. 회사는 사전에 결제정보를 입력 받고, 무료로 제공중인 서비스를 유료로 전환할 경우, 그 사유와 유료 전환 예정 일시를 통지하고 유료 전환에 대한 이용자의 동의를 받습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제16조(서비스의 해제·해지 및 탈퇴 절차)
          </p>
          <p className="padding-bottom">
            1. 이용자가 이용 계약을 해지하고자 할 때는 언제든지 홈페이지 상의 이용자 탈퇴 신청을 통해 이용계약 해지를 요청할 수 있습니다. 단, 신규가입 후 일정 시간 동안 서비스 부정이용 방지 등의 사유로 즉시 탈퇴가 제한될 수 있습니다.
          </p>
          <p className="padding-bottom">
            2. 회사는 이용자가 본 약관에서 정한 이용자의 의무를 위반한 경우 등 비정상적인 이용 또는 부당한 이용과 이용자 금지프로그램 사용하는 경우 또는 타인의 명예를 훼손하거나 모욕하는 방송과 게시물을 작성한 경우 이러한 행위를 금지하거나 삭제를 요청하였음에도 불구하고 최초의 금지 또는 삭제 요청을 포함하여 2회 이상 누적되는 경우 이용자에게 통지하고, 계약을 해지할 수 있습니다.
          </p>
          <p className="padding-bottom">
            3. 회사는 이용자의 청약철회, 해제 또는 해지의 의사표시를 수신한 후 그 사실을 이용자에게 회신합니다. 회신은 이용자가 회사에 대하여 통지한 방법 중 하나에 의하고, 이용자가 회사에 대하여 통지한 연락처가 존재하지 않는 경우에는 회신하지 않을 수 있습니다.
          </p>
          <p className="padding-bottom">
            4. 상담사 회원은 해지의사를 통지하기 전 또는 통지한 후라도 진행 중인 모든 판매 절차를 마무리하고 내부 규정에 따라 최종 계약 해지 과정을 진행합니다.
          </p>
          <p className="padding-bottom">
            5. 회사는 회원이 본 약관 또는 관계법령 등을 위반하는 경우, 이용계약을 해지할 수 있다.본 항에 따라 해지를 한 회원은 이 약관이 정하는 회원가입절차와 관련조항에 따라 회원으로 다시 가입할 수 있습니다. 다만 회원이 중복참여가 제한된 판촉이벤트 중복 참여 등 부정한 목적으로 회원탈퇴 후 재가입 신청하는 경우 회사가 재가입을 일정기간 동안 제한할 수 있습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제17조(손해배상)
          </p>
          <p className="padding-bottom">
            1. 회사 또는 이용자는 상대방의 귀책에 따라 손해가 발생하는 경우 손해배상을 청구할 수 있습니다. 다만, 회사는 무료서비스의 장애, 제공 중단, 보관된 자료 멸실 또는 삭제, 변조 등으로 인한 손해에 대하여는 배상책임을 부담하지 않습니다.
          </p>
          <p className="padding-bottom">
            2. 회사가 제공하는 서비스의 이용과 관련하여 회사의 운영정책 및 개인 정보 보호정책, 기타 서비스별 이용약관에서 정하는 내용에 위반하지 않는 한 회사는 어떠한 손해에 대하여도 책임을 부담하지 않습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제18조(면책사항)
          </p>
          <p className="padding-bottom">
            가. 이용자는 재화 등을 배송 받은 경우 다음 각 호에 해당하는 경우에는 반품 및 교환을 할 수 없다.이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있다)이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한 경우같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우
          </p>
          <p className="padding-bottom">
            나. 회사는 이용자가 서비스를 이용하며 기대하는 수익을 얻지 못한 것에 대하여 책임 지지 않으며 서비스를 통하여 얻은 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다.
          </p>
          <p className="padding-bottom">
            다. 회사는 이용자가 웹페이지에 게재한 내용의 신뢰도, 정확성 등 내용에 대해서는 책임지지 않으며, 이용자 상호간 또는 이용자와 제3자 상호간 서비스를 매개로 발생한 분쟁에 개입하지 않습니다.
          </p>
          <p className="padding-bottom">
            라. 회사는 회원 상호간 또는 회원과 제3자 간에 콘텐츠를 매개로 하여 발생한 분쟁 등에 대하여 책임을 지지 않습니다.
          </p>
          <p className="padding-bottom">
            마. 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하는 경우, 해당 위반자는 회사에 발생되는 모든 손해를 배상하여야 하며, 동 손해로부터 회사를 면책 시켜야 합니다.
          </p>
          <p className="padding-bottom">
            바. 회사는 상담사 회원이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여 상담사 회원이 기존에 회사에 제출한 서면자료가 위조, 변조되거나 기타 사유로 회사가 상담사 회원의 정보가 허위임을 인지하지 못한 경우에 대하여는 책임을 지지 않습니다.
          </p>
          <p className="padding-bottom">
            사. 회사는 회원에게 플랫폼을 제공하는 역할을 담당하며, 상담사 회원의 상담 내용에 대한 진위 등을 판단할 수 없다. 또한 일반 회원과 상담사 회원 간의 상담을 진행하는 과정에서 발생한 분쟁에 대해서는 개입할 수 없고 이로 인한 손해를 배상할 책임이 없습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제19조(정보의 제공 및 광고의 게재)
          </p>
          <p className="padding-bottom">
            1&#41; 회사는 이용자가 서비스 이용 중 필요하다고 인정되는 각종 정보 및 광고를 배너 게재, 전자우편(E-Mail), 휴대폰 메세지, 전화, 우편 등의 방법으로 이용자에게 제공(또는 전송)할 수 있습니다. 다만, 이용자는 이를 원하지 않을 경우 회사가 제공하는 방법에 따라 수신을 거부할 수 있습니다.
          </p>
          <p className="padding-bottom">
            2&#41; 이용자가 수신 거부를 한 경우에도 이용약관, 개인정보보호정책, 기타 이용자의 이익에 영향을 미칠 수 있는 중요한 사항의 변경 등 '정보통신망이용촉진 및 정보보호 등에 관한 법률'에서 정하는 사유 등 이용자가 반드시 알고 있어야 하는 사항에 대하여는 전자우편 등의 방법으로 정보를 제공할 수 있습니다.
          </p>
          <p className="padding-bottom">
            3&#41; 제1항 단서에 따라 이용자가 수신 거부 조치를 취한 경우 이로 인하여 회사가 거래 관련 정보, 이용 문의에 대한 답변 등의 정보를 전달하지 못한 경우 회사는 이로 인한 책임이 없습니다.
          </p>
          <p className="padding-bottom">
            4&#41; 회사는 '정보통신망법' 시행령에 따라 2년마다 영리 목적의 광고정 정보 전송에 대한 수신동의 여부를 확인합니다.
          </p>
          <p className="padding-bottom">
            5&#41; 회사는 광고주의 판촉 활동에 이용자가 참여하거나, 거래의 결과로서 발생하는 손실 또는 손해에 대하여는 책임을 지지 않습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제20조(유료서비스의 결제 등)
          </p>
          <p className="padding-bottom">
            1. 회사가 제공하는 유료서비스를 이용하는 경우 이용자는 이용대금을 납부하는 것을 원칙으로 합니다. 이 때 회사가 제공하는 유료서비스에 대한 이용요금의 결제방법은 아래 각 호와 같습니다.
          </p>
          <div className="padding-bottom padding-left">
            <div className="padding-bottom">
              가. 선불카드, 직불카드, 신용카드 등의 각종 카드결제
            </div>
            <div className="padding-bottom">
              나. 선물 검사코드
            </div>
          </div>
          <p className="padding-bottom">
            2. 회사는 이용자가 결제수단에 대해 정당한 사용권한을 가지고 있는지의 여부를 확인할 수 있으며, 이에 대한 확인이 완료될 때까지 거래 진행을 중지하거나, 확인이 불가한 해당 거래를 취소할 수 있습니다.
          </p>
          <p className="padding-bottom">
            3. 회사의 정책 및 제1항의 결제업체(이동통신사, 카드사 등) 및 결제대행업체의 기준에 따라 이용자 당 월 누적 결제액 및 충전한도가 제한될 수 있습니다. 해당 기준을 초과한 경우 유료서비스의 추가 이용은 불가능할 수 있습니다.
          </p>
          <p className="padding-bottom">
            4. 이용자가 대금의 지급이나 결제를 위하여 입력한 정보에 대한 책임은 이용자에게 있습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제21조(환불)
          </p>
          <p className="padding-bottom">
            1. 이용자의 귀책사유로 결제를 취소, 환불하는 경우에는 다음의 절차에 따릅니다.
          </p>
          <div className="padding-bottom padding-left">
            <div className="padding-bottom">
              가. 1회로 이용 또는 구매가 완료되는 서비스는 환불이 불가능 합니다.
            </div>
            <div className="padding-bottom">
              나. 지속적으로 이용가능한 서비스는 이용일수에 해당하는 금액을 차감한 나머지 금액을 환불합니다.
            </div>
          </div>
          <p className="padding-bottom">
            2. 전항의 규정에도 불구하고 아래 각 호의 경우에는 결제한 전액을 환불합니다.
          </p>
          <div className="padding-bottom padding-left">
            <div className="padding-bottom">
              - 결제를 완료한 후 서비스 이용 내역이 없는 경우
            </div>
            <div className="padding-bottom">
              - 서비스 장애 등 회사의 귀책사유로 서비스를 이용하지 못한 경우
            </div>
            <div className="padding-bottom">
              - 구매한 서비스가 제공되지 않은 경우
            </div>
            <div className="padding-bottom">
              - 구매한 서비스가 표시 또는 광고 등과 상이하거나 현저한 차이가 있는 경우
            </div>
            <div className="padding-bottom">
              - 서비스 자체의 결함으로 서비스 이용이 현저히 불가능 하였던 경우
            </div>
          </div>
          <p className="padding-bottom">
            3. 회사는 환불시 이용대금의 결제수단과 동일한 방법으로 환불하는 것을 원칙으로 합니다. 다만, 동일한 결제수단으로 환불이 불가능한 경우 회사가 개별서비스에서 정하는 별도의 방법으로 환불합니다.
          </p>
          <p className="padding-bottom">
            4. 회사는 환불 의무가 발생한 날로부터 3영업일 내에 환불절차를 진행합니다. 다만, 환불을 위하여 이용자의 협조가 필요한 경우 이용자의 귀책사유로 환불이 지연된 경우 회사는 지연이자를 부담하지 않습니다.
          </p>
          <p className="padding-bottom">
            5. 이용자는 재화 등을 배송 받은 경우 다음 각 호에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.
          </p>
          <div className="padding-bottom padding-left">
            <div className="padding-bottom">
              가&#41; 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있다)
            </div>
            <div className="padding-bottom">
              나&#41; 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우
            </div>
            <div className="padding-bottom">
              다&#41; 시간의 경과에 의하여 재판매가 곤란할 정도로 재화등의 가치가 현저히 감소한 경우
            </div>
            <div className="padding-bottom">
              라&#41; 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우
            </div>
          </div>
          <p className="padding-bottom">
            6. 환불에 필요한 비용은 귀책사유가 있는 쪽이 부담합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <h2>
            [제5장 저작권 정책]
          </h2>
          <p className="fulltext-title fulltext-title-bold">
            제22조(권리의 귀속)
          </p>
          <p className="padding-bottom">
            1. 회사가 제공하는 서비스에 대한 저작권 등 지식재산권은 회사에 귀속 됩니다.
          </p>
          <p className="padding-bottom">
            2. 회사는 서비스와 관련하여 이용자에게 회사가 정한 조건 따라 회사가 제공하는 서비스를 이용할 수 있는 권한만을 부여하며, 이용자는 이를 양도, 판매, 담보제공 하는 등 처분행위를 할 수 없습니다.
          </p>
          <p className="padding-bottom">
            3. 타인의 지적재산권에 속하는 대상물을 마인드아이티 내에서 이용할 경우에는 반드시 해당 권리자의 사전 동의를 받아야 합니다.
          </p>
          <p className="padding-bottom">
            4. 일반 회원과 상담사 회원이 상담과정에서 작성하는 상담내용과 게시하는 글과 사진 등 저작물의 저작권 내지 저작물의 이용권은 회사에 무상으로 영구히 귀속되고, 모든 자료와 정보를 익명화하여 수집하여 심리상담 및 정신건강 관련 연구, 통계, 솔루션 개발에 활용할 수 있습니다.
          </p>
          <p className="padding-bottom">
            5. 더 나아가 빅데이터 활용 내지 연구를 위해 제3자에게 재이용권을 허락할 수 있다는 사실을 인정하고 동의합니다.
          </p>
          <p className="padding-bottom">
            6. 서비스의 내용은 포털사이트 등 인터넷의 검색 결과 내지 서비스 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 편집되어 게시될 수 있습니다.
          </p>
          <p className="padding-bottom">
            7. 또한 약관에 의해 포털사이트 등에서 운영하는 타 서비스 등에 전송되거나 게시될 수 있습니다.
          </p>
          <p className="padding-bottom">
            8. 일반회원 및 상담사 회원은 서비스를 이용함으로써 얻은 정보 내지 상담 내용을 외부에 공개하거나 회사의 사전 승낙 없이 복제, 송신, 출판, 전송, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 해서는 안 됩니다.회사의 서비스에 게재 또는 등록된 회원의 게시물을 제3자가 사용하고자 할 경우에는 반드시 해당 회원의 명시적 동의를 얻은 뒤 사용해야 합니다. 단, 약관에 따라 이용리뷰 등의 콘텐츠가 네이버, 다음 등의 포털사이트 등에 전송, 게시되는 경우에는 그러하지 아니합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <h2>
            [제 6장 회원자격 박탈 및 분쟁의 조정]
          </h2>
          <p className="fulltext-title fulltext-title-bold">
            제23조 (회원자격의 박탈)
          </p>
          <p className="padding-bottom">
            회사는 다음 각 호의 경우 회원의 서비스 이용기간을 제한하거나 회원자격을 예고 없이 박탈할 수 있습니다.
          </p>
          <div className="padding-left">
            <div className="padding-bottom">
              a&#41; 회원의 개인신상정보가 사실과 다를 경우
            </div>
            <div className="padding-bottom">
              b&#41; 타인에게 ID를 양도, 대여한 경우
            </div>
            <div className="padding-bottom">
              c&#41; 다른 이용자의 ID를 부정 사용한 경우
            </div>
            <div className="padding-bottom">
              d&#41; 서비스를 통하여 취득한 다른 회원의 정보를 수집, 저장, 양도하거나 중개에 이용한 경우
            </div>
            <div className="padding-bottom">
              e&#41; 불법정보, 유해정보 또는 회사로부터 허가 받지 않은 광고, 브로커 제안, 장난글 등을 게시한 경우
            </div>
            <div className="padding-bottom">
              f&#41; 서비스를 통해 진행한 상담의 내용을 회사 및 일반 회원 또는 상담사 회원의 사전 승낙없이 복제ㆍ편집ㆍ전시ㆍ전송ㆍ배포ㆍ판매ㆍ방송ㆍ공연하는 등의 행위를 한 경우
            </div>
            <div className="padding-bottom">
              g&#41; 회사 직원, 운영자 등을 포함한 타인을 사칭한 경우
            </div>
            <div className="padding-bottom">
              h&#41; 서비스의 운영에 지장을 주거나 줄 우려가 있는 행위를 한 경우
            </div>
            <div className="padding-bottom">
              i&#41; 본 약관을 포함하여 기타 회사가 정한 규정 또는 이용조건을 위반한 경우
            </div>
            <div className="padding-bottom">
              j&#41; 직거래 또는 직거래 유도행위를 시도할 경우
            </div>
            <div className="padding-bottom">
              k&#41; 성적인 대화, 협박, 욕설, 스토킹 등 다른 회원을 괴롭히는 행위를 한 경우
            </div>
            <div className="padding-bottom">
              l&#41; 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 컴퓨터 바이러스, 기타 다른 컴퓨터코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 전자우편으로 배포하는 행위를 한 경우
            </div>
            <div className="padding-bottom">
              m&#41; 상담사 회원이 사유를 전달 하지 않은 상태로 2달 이상 미접속 하는 경우
            </div>
            <div className="padding-bottom">
              n&#41; 상담사 회원이 회사와 협의없이 이용자에게 타 서비스를 안내한 경우
            </div>
            <div className="padding-bottom">
              o&#41; 기타 법령에 위배되는 행위를 한 경우
            </div>
            <div className="padding-bottom">
              p&#41; 기타 내규에 위배되는 행위를 한 경우
            </div>
            <div className="padding-bottom">
              q&#41; 부정한 방법으로 서비스를 이용하거나 정보를 조작하여, 회사에 피해를 줄 수 있다고 판단되는 경우
            </div>
            <div className="padding-bottom">
              r&#41; 신청 시 필요한 사항을 허위로 기재하거나 중대한 사항에 기재누락, 오기가 있는 경우
            </div>
          </div>
          <p>
            회사는 회원의 서비스 이용 권한을 일정 기간 제한하거나 이용 권한을 박탈한 경우, 회원에게 시정 또는 소명 기회를 부여할 수 있다. 회원의 이의신청이 정당한 경우 회사는 즉시 회원이 서비스를 이용할 수 있도록 필요한 조치를 취하여야 합니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            제24조(분쟁의 해결)
          </p>
          <p className="padding-bottom">
            1. '회사'는 '이용자'가 제기하는 불만사항 및 의견을 지체없이 처리하기 위하여 노력합니다. 다만, 신속한 처리가 곤란한 경우 '이용자'에게 그 사유와 처리일정을 즉시 통보합니다.
          </p>
          <p className="padding-bottom">
            2. '회사'와 '이용자'간 발생한 분쟁에 관한 소송은 '회사' 소재지를 관할 하는 법원을 제1심 관할 법원으로 하며, 준거법은 대한민국의 법령을 적용합니다.
          </p>
          <p className="padding-bottom">
            3. 회사가 제공하는 서비스는 합법적인 목적으로만 사용되어야 하며, 대한민국 법령에반하는 형태의 사용은 금지된다. 회원의 금지된 형태의 사용으로 인하여 손해가 발생할 경우 회사는 이에 대하여 책임을 지지 않습니다.
          </p>
        </div>
        <div className="fulltext-item">
          <p className="fulltext-title fulltext-title-bold">
            부 칙
          </p>
          <p className="fulltext-subtitle">
            제1조(시행일)
          </p>
          <p className="padding-bottom">
            본 약관은 2024.09.16.부터 시행됩니다.
          </p>
        </div>
      </div>

      <div id="footer"></div>
    </div>
  )
}

export default Service